export default __webpack_public_path__ + "static/media/stands_ind_cooper.c5fe8c49.jpg";